export default "__VITE_ASSET__CcSPjg$H__"